import script from "./FormCadastroAtividade.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCadastroAtividade.vue?vue&type=script&setup=true&lang=js"

import "./FormCadastroAtividade.vue?vue&type=style&index=0&id=655b1e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-655b1e86"]])

export default __exports__